import ShellIpcRouter, { type ShellIpcRouterType } from '@shared/ipc/routers/ShellIpc.router'
import type { ShellInfo, ShellSessionId, OpenShellArgs, TmuxStatus } from '@shared/types/ShellTypes'

class ShellIpcRenderer extends ShellIpcRouter implements ShellIpcRouterType {
  async listShells(): Promise<Array<ShellInfo>> {
    return this.exec('listShells')
  }

  async spawnShell(args: OpenShellArgs): Promise<ShellInfo> {
    return this.exec('spawnShell', args)
  }

  async killShell(id: ShellSessionId): Promise<boolean> {
    return this.exec('killShell', id)
  }

  async openShell(id: ShellSessionId): Promise<boolean> {
    return this.exec('openShell', id)
  }

  async getTmuxStatus(): Promise<TmuxStatus> {
    return this.exec('getTmuxStatus')
  }
}

export default new ShellIpcRenderer()
